import { useParams, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import ModernCalendarView from "../components/views/ModernCalendarView";

export default function CalendarV2Page() {
  const { projectId } = useParams();
  const [searchParams] = useSearchParams();
  const projectIdFromParams = projectId || searchParams.get('projectId');

  useEffect(() => {
    document.title = "TaskManager - Calendario";
  }, []);

  return (
    <ModernCalendarView projectId={projectIdFromParams || undefined} />
  );
}
